


import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import {AnswerFeedback, InteractiveObject} from '@/interfaces/entities/forest-game.interface';
import ForestGameService from '@/services/forest-game.service';
import TranslationsService from '@/services/translations.service';
import {finalize} from 'rxjs/operators';
import {AxiosResponse} from 'axios';
import PopupService from '@/services/popup.service';
import {ForestGame} from '@/library/forest-game/forest-game';

declare const jQuery: any;

@Component({})
export default class AppGameObject extends Vue {

  @Prop()
  public game!: ForestGame;

  @Prop()
  public interactiveObject!: InteractiveObject;

  $refs!: {
    description: HTMLElement;
  }

  @Emit('close')
  public emitClose(): void {
  }

  @Emit('completed-interactive-object')
  public emitCompletedInteractiveObject(userCompletedTasks: string[]): string[] {
    return userCompletedTasks;
  }

  @Watch('interactiveObject')
  public interactiveObjectChanged() {
    this.checkedAnswers = [];
    this.errorMessage = '';
    this.taskHint = '';
    this.loading = false;
    this.responseMessage = '';
    this.feedbacks = {};
  }

  @Watch('checkedAnswers', {deep: true, immediate: false})
  public answersChanged() {
    this.errorMessage = '';
  }

  public checkedAnswers: string[] = [];
  public errorMessage = '';
  public taskHint: string = '';
  public loading: boolean = false;
  public responseMessage: string = '';
  public feedbacks: { [answerId: string]: AnswerFeedback } = {};
  private forestGameService: ForestGameService = ForestGameService.getInstance();
  private translations: TranslationsService = TranslationsService.getInstance();
  private popupService: PopupService = PopupService.getInstance();

  public mounted(): void {
    this.wrapIframe();
  }

  public close(): void {
    this.emitClose();
  }

  public isAnswered(): boolean {
    return this.game.isInteractiveObjectCompleted(this.interactiveObject);
  }

  public handleUserAnswers(): void {
    if (this.isAnswerSelected()) {
      this.sendAnswers();
    } else {
      this.errorMessage = this.translations.translation('COM_MAMMADABA_MAP_FOREST_GAME_EMPTY_ANSWER');
    }
  }

  private answers(): string[] {
    return this.checkedAnswers.filter((answerId: string | null) => !!answerId);
  }

  private sendAnswers(): void {
    this.loading = true;
    this.forestGameService.sendAnswers(this.formData())
        .pipe(finalize(() => this.loading = false))
        .subscribe({
          next: (response: AxiosResponse) => {
            if (response.data.data.doubleAnswers) {
              this.popupService.open('infoDoubleAnswers').subscribe();
              this.close();
            } else {
              this.printResponse(response.data)
            }
            this.emitCompletedInteractiveObject(response.data.data.completedObjects);
          },
          error: (error: Error) => {
            this.popupService.open('infoError').subscribe();
          },
        });
  }

  private formData(): FormData {
    let formData = new FormData();
    formData.append('task', this.taskId());
    formData.append('id', this.game.id());
    this.answers().map((answerId: string, index: number) => {
      formData.append('answers[' + index + ']', answerId);
    });
    return formData;
  }

  private taskId(): string {
    const formElement: HTMLElement = this.$el.getElementsByTagName('form')[0];
    return String(formElement.getAttribute('data-id'));
  }

  private isAnswerSelected(): boolean {
    return this.answers().length > 0;
  }

  private wrapIframe(): void {
    const iframe = this.$refs.description.getElementsByTagName('iframe');
    if (iframe.length) {
      for (let i = 0; i < iframe.length; i++) {
        iframe[i].closest('p')!.classList.add('iframe-container');
      }
    }
  }

  private printResponse(response: any): void {
    if (response.data.hint) {
      this.taskHint = response.data.hint;
    }
    if (typeof response.data.feedback === 'string') {
      this.responseMessage = response.data.feedback;
    } else {
      this.feedbacks = response.data.feedback;
    }
  }
}
